var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoTabletDeskFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#EBF3D4",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8BAA36",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 10.103V15.666v-.11c0 1.557.68 2.936 1.733 3.828.515.437.855 1.026.855 1.68v9.103c0 1.012.87 1.833 1.941 1.833 1.072 0 1.942-.821 1.942-1.833v-9.103c0-.654.34-1.243.855-1.68 1.053-.892 1.733-2.27 1.733-3.828v-5.453 5.453M14.53 16.111V10M32 11.285c0-.674-.58-1.222-1.294-1.222h-1.294c-2.145 0-3.883 1.641-3.883 3.667v7.333c0 1.594 1.084 2.937 2.588 3.442v5.661c0 1.012.87 1.834 1.942 1.834 1.071 0 1.94-.822 1.94-1.834V11.285Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTabletDeskFooter);
export default __webpack_public_path__ + "static/media/logo_tablet-desk_footer.3973999e1d5e8f9f9106b706397f54e9.svg";
export { ForwardRef as ReactComponent };